var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSlowDashPort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slow_BG_-Buildings",
    "data-name": "Slow BG -Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6131 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #181216;\n      }\n\n      .cls-2 {\n        fill: #ac22b3;\n      }\n\n      .cls-3 {\n        fill: #1c151a;\n      }\n\n      .cls-4 {\n        fill: #008d9b;\n      }\n\n      .cls-5 {\n        fill: #008b99;\n      }\n\n      .cls-6 {\n        fill: #181217;\n      }\n\n      .cls-7 {\n        fill: #008e9c;\n      }\n\n      .cls-8 {\n        fill: #322930;\n      }\n\n      .cls-9 {\n        fill: #931d99;\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        fill: #961e9c;\n      }\n\n      .cls-12 {\n        fill: #008c9b;\n      }\n\n      .cls-13 {\n        fill: #191217;\n      }\n\n      .cls-14 {\n        fill: #332931;\n      }\n\n      .cls-15 {\n        fill: #00a2b3;\n      }\n\n      .cls-16 {\n        fill: #392f37;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3813.08 1054.96 3761.77 1054.96 3759.69 1052.94 3811 1052.94 3813.08 1054.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3811 1055.94 3759.69 1055.94 3761.1 1054.31 3812.41 1054.31 3811 1055.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "3808.92 1050.91 3757.61 1050.91 3758.45 1049.94 3809.75 1049.94 3808.92 1050.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3666.11 1049.94 3614.81 1049.94 3758.45 1049.94 3809.75 1049.94 3666.11 1049.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3613.56,
    y: 1052.94,
    width: 51.3,
    height: 3.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3664.86 1049.94 3613.56 1049.94 3614.81 1049.94 3666.11 1049.94 3664.86 1049.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3613.56,
    y: 1049.94,
    width: 51.3,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3811 1052.94 3759.69 1052.94 3757.61 1050.91 3808.92 1050.91 3811 1052.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "3809.75 1049.94 3808.92 1050.91 3811 1052.94 3811 1055.94 3664.86 1055.94 3664.86 1052.94 3664.86 1049.94 3666.11 1049.94 3809.75 1049.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3662.78 1054.96 3611.48 1054.96 3307.57 701.72 3358.87 701.72 3662.78 1054.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3168.48 1799.76 3117.18 1799.76 3120.67 1795.7 3171.98 1795.7 3168.48 1799.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3358.87 701.72 3662.78 1054.96 3811 1055.94 4116.96 701.75 4200.25 1222.97 4116.36 1577.74 4190.07 1607.98 4307.38 1795.7 4303.88 1795.7 4307.38 1799.76 4116.36 1799.76 3359.5 1799.76 3168.48 1799.76 3171.98 1795.7 3168.48 1795.7 3285.79 1607.98 3359.5 1577.74 3270.91 1222.97 3358.87 701.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3809.75 1049.94 3808.92 1050.91 3811 1052.94 3812.41 1054.31 4116.96 701.75 4065.66 701.75 3764.88 1049.94 3809.75 1049.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "3809.75 1049.94 3758.45 1049.94 4062.98 695.98 4114.28 695.98 3809.75 1049.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "4114.28 695.98 4118.44 700.03 4116.96 701.75 3813.08 1054.96 3811 1052.94 3808.92 1050.91 3809.75 1049.94 4114.28 695.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3357.42 700.03 3306.12 700.03 3310.28 695.98 3361.58 695.98 3357.42 700.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "3361.58 695.98 3666.11 1049.94 3664.86 1049.94 3664.86 1052.94 3662.78 1054.96 3358.87 701.72 3357.42 700.03 3361.58 695.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3358.87 701.72 3307.57 701.72 3306.12 700.03 3357.42 700.03 3358.87 701.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "3285.79 1607.98 3234.49 1607.98 3308.2 1577.74 3359.5 1577.74 3285.79 1607.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3270.91 1222.97 3219.61 1222.97 3307.57 701.72 3358.87 701.72 3270.91 1222.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3359.5 1577.74 3308.2 1577.74 3219.61 1222.97 3270.91 1222.97 3359.5 1577.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3168.48 1795.7 3117.18 1795.7 3234.49 1607.98 3285.79 1607.98 3168.48 1795.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 3666.98,
    y: 1059.3,
    width: 143,
    height: 740.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3661.85,
    y: 1059.3,
    width: 5.13,
    height: 740.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "3666.98 1059.3 3661.85 1059.3 3804.85 1059.3 3809.98 1059.3 3666.98 1059.3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 789.04,
    y: 297.97,
    width: 51.3,
    height: 1083.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "840.35 297.97 789.04 297.97 993.81 105.23 1045.11 105.23 840.35 297.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "828.77 297.75 777.47 297.75 787.51 297.75 838.82 297.75 828.77 297.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "609.39 1719.9 558.09 1719.9 789.04 1381.42 840.35 1381.42 609.39 1719.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "838.82 297.75 838.82 1379.51 828.77 1388.42 828.77 297.75 838.82 297.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 777.47,
    y: 297.75,
    width: 51.3,
    height: 1090.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1045.11 105.23 1158.32 1225.79 1306.05 1443.67 1306.56 1799.59 840.49 1799.59 609.39 1800.1 609.39 1719.9 840.35 1381.42 840.35 297.97 1045.11 105.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 558.09,
    y: 1719.9,
    width: 51.3,
    height: 80.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "808.8 1621.48 803.67 1621.48 1240.02 1621.48 1245.15 1621.48 808.8 1621.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1245.15 1621.48 1245.15 1716.88 733.62 1716.88 808.8 1621.48 1245.15 1621.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "733.62 1716.88 728.49 1716.88 803.67 1621.48 808.8 1621.48 733.62 1716.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlowDashPort);
export default __webpack_public_path__ + "static/media/bg-slow-dash-port.06b73f6fc3f54618961d83fb2dd8cad3.svg";
export { ForwardRef as ReactComponent };